export default __webpack_public_path__ + "static/media/03.43d97450.jpg";